const WINDOW_MS = 24 * 60 * 60 * 1000;
const MIN_INTERVAL_MS = 20_000;

export interface ValueSample {
  t: number;
  value: number;
}

function key(account: string) {
  return `pelagos-portfolio-${account.toLowerCase()}`;
}

function load(account: string): ValueSample[] {
  try {
    const raw = localStorage.getItem(key(account));
    if (!raw) return [];
    const parsed = JSON.parse(raw) as ValueSample[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

// records at most one sample per ~20s per account, pruned to a 24h window
export function recordPortfolioValue(account: string, value: number) {
  if (!Number.isFinite(value)) return;
  const samples = load(account);
  const now = Date.now();
  const last = samples[samples.length - 1];
  if (last && now - last.t < MIN_INTERVAL_MS) return;
  samples.push({ t: now, value });
  const cutoff = now - WINDOW_MS;
  const pruned = samples.filter((s) => s.t >= cutoff);
  try {
    localStorage.setItem(key(account), JSON.stringify(pruned));
  } catch {
    // storage full / disabled — history is best-effort
  }
}

export function readPortfolioHistory(account: string): ValueSample[] {
  const cutoff = Date.now() - WINDOW_MS;
  return load(account).filter((s) => s.t >= cutoff);
}
